import { asHintId, type Hint } from '@/shared/stores';

import { PROPOSED_ACTIONS_FIRST_ACTION_ANCHOR } from './anchors';

export const proposedActionHint: Hint = {
  id: asHintId('patient-workspace:proposed-action'),
  version: 1,
  priority: 90,
  anchor: PROPOSED_ACTIONS_FIRST_ACTION_ANCHOR,
  copy: {
    title: 'A proposed action',
    body: 'These help resolve the request. Each one can be executed directly to launch a lab order, prescription, or follow-up.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
